import { Body, Box, BoxProps, Divider, Heading } from '@hover/blueprint';
import { navigate } from 'gatsby';
import React from 'react';
import { SCHEDULE_A_MEETING_LINK } from '../../../../constants';
import ArrowButton from '../../../ui/ArrowButton';
import PremiumFeaturesMobile from './PremiumFeaturesMobile';
import PremiumFeatureTabletAndDesktop from './PremiumFeatureTabletAndDesktop';

interface Props extends BoxProps {}

const Premium: React.FC<Props> = props => {
  const navigateTo = () => navigate(SCHEDULE_A_MEETING_LINK);

  return (
    <Box
      w={{ base: '100%', tablet: '353px', desktop: '380px' }}
      position="relative"
      borderRadius="8px"
      shadow="distance300"
      flexDir="column"
      overflow="hidden"
      {...props}
    >
      <Box position="absolute" top={0} bg="brandBrown.500" h={50} w="100%" />
      <Box
        pt={{ base: 600, tablet: '78px' }}
        px={{ base: '28px', desktop: 700 }}
        flexDir="column"
        alignItems="center"
        bg="primary.600"
        w="100%"
      >
        <Heading
          size={{ base: 500, tablet: 600 }}
          marginBottom={{ base: 400, tablet: 500 }}
          color="neutral.0"
        >
          Premium
        </Heading>
        <Body
          color="neutral.0"
          size={{ base: 500, tablet: 600 }}
          marginBottom={{ base: 500, tablet: 600 }}
          textAlign="center"
        >
          Expanded tools and features with dedicated support to power your
          workflow.
        </Body>
        <ArrowButton
          colorScheme="primary"
          mb={{ base: 400, tablet: 600 }}
          variant="inverted"
          onClick={navigateTo}
        >
          Contact sales
        </ArrowButton>
      </Box>
      <Box
        px={{ base: 700, tablet: '45px', desktop: '57px' }}
        bg={{ base: 'primary.600', tablet: 'neutral.0' }}
      >
        <Body
          textAlign="center"
          mt={{ base: 0, tablet: 600 }}
          size={{ base: 500, tablet: 600 }}
          mb={{ base: 400, tablet: 500 }}
          color={{ base: 'neutral.0', tablet: 'neutral.700' }}
          isSemiBold
          mx="auto"
        >
          Discounted property rates, with membership fee
        </Body>
      </Box>
      <Box bg={{ base: 'primary.600', tablet: 'neutral.0' }} px={400}>
        <Divider borderColor={{ base: 'neutral.0', tablet: 'neutral.300' }} />
      </Box>
      <PremiumFeaturesMobile />
      <PremiumFeatureTabletAndDesktop />
    </Box>
  );
};

export default Premium;
